import { Dialog, Button, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
import { toTitleCase } from '../../../utils';
import { useContent } from '../../../logic'

interface CompletePayloadTaskDialogProps {
    open: boolean;
    setUserCompleteOpen: (open: boolean) => void;
    onUserCompleteTask: () => void;
}

export function CompletePayloadTaskNoAmountRemainingDialog({ open, setUserCompleteOpen, onUserCompleteTask }: CompletePayloadTaskDialogProps) {

  const { TaskText } = useContent()

  return <Dialog key="userComplete" open={open}>
    <DialogTitle>Complete {toTitleCase(TaskText)}</DialogTitle>

    <DialogContent>
      <DialogContentText sx={{ mb: 1 }}>It looks like you’ve submitted your total cash to close amount.</DialogContentText>
      <DialogContentText>Mark this {TaskText} as complete?</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="rounded" onClick={() => setUserCompleteOpen(false)}>
                Not yet
      </Button>
      <Button variant="contained" onClick={onUserCompleteTask}>
                Yes, complete it
      </Button>
    </DialogActions>
  </Dialog>
}
